import {createRouter, createWebHashHistory, RouteRecordRaw} from "vue-router";
import Tarefas from "@/views/Tarefas.vue";
import Projetos from "@/views/Projetos.vue";

const rotas: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'Tarefas',
        component: Tarefas,
    },
    {
        path: '/projetos',
        name: 'Projeto',
        component: Projetos,
    }
];
const router = createRouter({
    history: createWebHashHistory(),
    routes: rotas
})

export default router
